import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import Screen from '../../shared/components/screen';
import {VisuallyImpairedProps} from '../../shared/components/visuallyImpaired/form/model';
import {Button} from '../../shared/components/button';
import {Hr} from '../../shared/components/hr';
import {images} from '../../assets/icons';
import {useTheme} from '../../shared/theme';
import {VisuallyImpairedFormMobile} from '../../shared/components/visuallyImpaired/formMobile';
import {CustomScrollView} from '../../shared/components/scrollView';
import {useStyles} from '../../shared/hooks/styles';
import {getFontWeight} from '../../shared/theme/default';

export interface IStateProps extends VisuallyImpairedProps {
  onGoBackClick: () => void;
  onDefaultVersion: () => void;
}

export default ({onDefaultVersion, onGoBackClick}: IStateProps) => {
  const styles = useStyles(({theme}) => ({
    fieldWrapper: {
      marginBottom: 36,
    },
    closeButton: {
      position: 'absolute',
      right: 28,
      top: 28,
      zIndex: 2,
    },
    buttonDefault: {
      width: 204,
      margin: 0,
    },
    topBar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      height: 54,
      paddingHorizontal: 12,
    },
    screenTitle: {
      fontWeight: getFontWeight('500'),
      fontFamily: theme.fonts.fontFamily.medium,
      fontSize: 16,
      lineHeight: 22,
      marginLeft: 19,
    },
    container: {
      paddingHorizontal: 20,
      paddingTop: 30,
      paddingBottom: 30,
      position: 'relative',
    },
    settingContainer: {
      marginBottom: theme.screen.bottomOffset,
    },
    settingLabel: {
      marginBottom: 12,
      fontFamily: 'Arial',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: 18,
    },
    fontSerifSettingLabel: {
      marginBottom: 18,
    },
  }));
  const theme = useTheme();

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.container}>
          <View style={styles.closeButton}>
            <TouchableOpacity testID='impaired-settings-close-id' onPress={onGoBackClick}>
              <images.Close width={24} height={24} color={theme.color.primaryBlackColor} />
            </TouchableOpacity>
          </View>
          <VisuallyImpairedFormMobile groupStyle={styles.fieldWrapper} />
          <View>
            <Button
              id='impaired-settings-defaults'
              style={styles.buttonDefault}
              text='Обычная версия'
              type='primary'
              onPress={onDefaultVersion}
            />
          </View>
          <Hr />
          <View style={styles.fieldWrapper}>
            <Button id='impaired-settings-back' text='Вернуться назад' type='secondary' onPress={onGoBackClick} block />
          </View>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
